// extracted by mini-css-extract-plugin
export default {"root":"Giftcards_root__IJ5fI"};